import { assert, subTestContext, Test } from "oc-e2e-testrunner";
import {
  assertSegmentIstLückenlosGefüllt,
  createElement,
  createStreckeWithMauerUndBreite,
  resetArrangement,
} from "./utils";
import {
  getAngrenzendeTeile,
  getEntferntAngrenzendeFreiraumBreiteSumme,
  getSollZwischenabstandVerbose,
  getZwischenabstandAnSeite,
  getZwischenabstandAnSeiteVerbose,
  LINKS,
  nullEpsilon,
  RECHTS,
} from "../arrangement/elementFunctions";
import { Arrangement } from "../arrangement/Arrangement";
import { Segment } from "../arrangement/Segment";
import { ZElement } from "../arrangement/ZElement";
import { findPathIntersectionCached } from "oc-app/metadata/GraphMetadata";
import { v2 } from "oc-threejs/short3";
import * as Maths from "oc-commons/Maths";
import { MObjekt } from "../../metamodell";
import { PAuswahlwert } from "../../metamodell_paths";

export default {
  name: "TestInsertMasselementeAutomatisch",
};

// Dieser Testcase ist ausgeschaltet, weil das Feature nicht umgesetzt ist - denn Leerraum füllen verschiebt absichtlicht keine vorhandenen Elemente!
// export const testElementInSchmalenLeerraumLinksEinfügenWennAusreichenderLeerraumGanzRechts: Test =
//   async () => {
//     const massAuswahlwert = APP.richMetadata.findAuswahlwert("180x180_Easy");
//     const agt = APP.arrangement;
//     resetArrangement();
//     agt.grundriss.setStandardForm("Strecke",[6]);
//     agt.fillEmptySegmentsWithElements();
//     agt.update3d();
//     const s = agt.segmente[0];
//     s.getElemente()[3].uiRemove();
//     s.getElemente()[0].uiRemove();
//     agt.update3d();
//     APP.arrangement.setSelectedObjects(s.empties[0]);
//     const freiraumBreite = getEntferntAngrenzendeFreiraumBreiteSumme(s.empties[0]);
//     assert.equals(1.82, freiraumBreite, "Der gelöschte Platz ist frei");
//     agt.changeSelectedZaunElemente({
//       massAuswahlwert,
//     });
//     agt.update3d();
//     assert.equals(
//       1.78,
//       s.getElemente()[0].breite,
//       "Das Element soll die Standardbreite haben, weil es genug Platz gibt"
//     );
//     assert.equals(3, s.getElemente().length, "Das Nachbarelement soll nicht gelöscht werden");
//   };

export const testTorMitSnapNachRechtsUndAusreichendPlatzVergrößert: Test = async () => {
  const agt = APP.arrangement;
  resetArrangement();
  agt.grundriss.setStandardForm("Strecke", [5]);
  agt.update3d();
  const s = agt.segmente[0];
  APP.arrangement.setSelectedObjects(s.empties[0]);
  agt.update3d();
  agt.changeSelectedZaunElemente({
    massAuswahlwert: APP.richMetadata.findAuswahlwert("Einzeltor_Easy"),
  });
  agt.update3d();
  assert.equals(1, s.getElemente().length);
  const element = s.getElemente()[0];
  element.setKonfigurierbareBreite(1.58);
  agt.update3d();
  assert.equals(1, s.getElemente().length);
  assert.equals(1.58, element.breite);
};

export const testKeramikElementGrößenwechselNebenLeerraum: Test = async () => {
  const füllungAuswahlwert = APP.richMetadata.findAuswahlwert("Keramik Zement");
  const agt = APP.arrangement;
  resetArrangement();
  agt.grundriss.setStandardForm("Strecke", [3]);
  agt.update3d();
  const s = agt.segmente[0];
  APP.arrangement.setSelectedObjects(s.empties[0]);
  agt.update3d();
  agt.changeSelectedZaunElemente({
    massAuswahlwert: APP.richMetadata.findAuswahlwert("120x180_Easy"),
    füllungAuswahlwert,
    maximumNumberOfElements: 1,
  });
  agt.update3d();
  assert.equals(1, s.getElemente().length);
  const element = s.getElemente()[0];
  assert.equals(füllungAuswahlwert, element.füllungAuswahlwert);
  APP.arrangement.setSelectedObjects(element);
  for (const { key, breite } of [
    { key: "90x180_Easy", breite: 0.9 },
    { key: "120x180_Easy", breite: 1.2 },
    { key: "180x180_Easy", breite: 1.2 },
  ]) {
    await subTestContext(
      `change auf Keramik Zement mit Mass ${key} soll ${breite} Breite ergeben:`,
      () => {
        agt.changeSelectedZaunElemente({
          massAuswahlwert: APP.richMetadata.findAuswahlwert(key),
        });
        agt.update3d();
        assert.equals(breite, element.breite);
        assert.equals(füllungAuswahlwert, element.füllungAuswahlwert);
        assert.equals(1, s.getElemente().length);
      }
    );
  }
};

export const testKeramikElementGrößenwechselAuf180x180NebenLeerraum: Test = async () => {
  const füllungAuswahlwert = APP.richMetadata.findAuswahlwert("Keramik Zement");
  const agt = APP.arrangement;
  resetArrangement();
  agt.grundriss.setStandardForm("Strecke", [3]);
  agt.update3d();
  const s = agt.segmente[0];
  APP.arrangement.setSelectedObjects(s.empties[0]);
  agt.update3d();
  agt.changeSelectedZaunElemente({
    massAuswahlwert: APP.richMetadata.findAuswahlwert("120x180_Easy"),
    füllungAuswahlwert,
    maximumNumberOfElements: 1,
  });
  agt.update3d();
  const element = s.getElemente()[0];
  assert.equals(füllungAuswahlwert, element.füllungAuswahlwert);
  APP.arrangement.setSelectedObjects(element);
  const füllungAuswahlwert2 = APP.richMetadata.findAuswahlwert("SYSTEM WPC CLASSIC Anthrazit");
  agt.changeSelectedZaunElemente({
    massAuswahlwert: APP.richMetadata.findAuswahlwert("180x180_Easy"),
    füllungAuswahlwert: füllungAuswahlwert2,
  });
  agt.update3d();
  assert.equals(1, s.getElemente().length);
  assert.equals(füllungAuswahlwert2, element.füllungAuswahlwert);
  assert.equals(
    APP.richMetadata.findEnsureAnyObjekt(
      "2143 SYSTEM WPC CLASSIC  Anthrazit/Anthrazit Zaunfeld-Set 178 x 183 cm"
    ),
    element.meta
  );
  assert.equals(1.78, element.breite);
};

export const testKeramikElementGrößenwechselInGefüllterStrecke: Test = async () => {
  const füllungAuswahlwert = APP.richMetadata.findAuswahlwert("Keramik Zement");
  const agt = APP.arrangement;
  resetArrangement();
  agt.grundriss.setStandardForm("Strecke", [3]);
  agt.update3d();
  const s = agt.segmente[0];
  APP.arrangement.setSelectedObjects(s.empties[0]);
  agt.update3d();
  agt.changeSelectedZaunElemente({
    massAuswahlwert: APP.richMetadata.findAuswahlwert("90x180_Easy"),
    füllungAuswahlwert,
    maximumNumberOfElements: 1,
  });
  agt.update3d();
  const element = s.getElemente()[0];
  agt.fillIndividuellSegmentsWithElements();
  agt.update3d();
  return;
  assert.equals(3, s.getElemente().length);
  assert.equals(füllungAuswahlwert, element.füllungAuswahlwert);
  assertSegmentIstLückenlosGefüllt(s);
  APP.arrangement.setSelectedObjects(element);
  agt.changeSelectedZaunElemente({
    massAuswahlwert: APP.richMetadata.findAuswahlwert("120x180_Easy"),
  });
  agt.update3d();
  assert.equals(füllungAuswahlwert, element.füllungAuswahlwert);
  assert.equals(1.2, element.breite);
  // die anderen Elemente fliegen raus
  assert.equals(1, s.getElemente().length);
  assert.deepEquals([], s.getÜberstände());
};

export const testMauerLinksChangeElementToTorAndElementeAufrücken: Test = async () => {
  const { agt, s } = createStreckeWithMauerUndBreite(1.2 - 0.5, { links: true });
  APP.arrangement.setSelectedObjects(s.empties[0]);
  agt.update3d();
  agt.changeSelectedZaunElemente({
    massAuswahlwert: APP.richMetadata.findAuswahlwert("90x180_Easy"),
    maximumNumberOfElements: 1,
  });
  agt.update3d();
  const element = s.getElemente()[0];
  APP.arrangement.setSelectedObjects(element);
  const elementMeta = APP.richMetadata.findEnsureAnyObjekt(
    "2499 SYSTEM WPC Classic Mass Einzeltor zweiseitig_15"
  );
  const soll = [LINKS, RECHTS].map((richtung) =>
    getSollZwischenabstandVerbose(element, elementMeta, richtung)
  );
  const massAuswahlwert = APP.richMetadata.findAuswahlwert("Einzeltor_Easy");
  agt.changeSelectedZaunElemente({ massAuswahlwert });
  agt.update3d();
  // Elemente aufrücken
  APP.arrangement.setSelectedObjects(s.empties[0]);
  await APP.arrangement.removeSelectedObjects();
  const ist = [LINKS, RECHTS].map((richtung) =>
    getZwischenabstandAnSeiteVerbose(element, richtung)
  );
  assert.deepEqualsPicked(
    ist,
    soll,
    "assert.deepEquals(soll,ist) failed: rot=getSollZwischenabstandVerbose, grün=getZwischenabstandAnSeiteVerbose"
  );
};

export const testMauerRechtsChangeElementToTor: Test = async () => {
  const { agt, s } = createStreckeWithMauerUndBreite(1.2 - 0.5, { rechts: true });
  APP.arrangement.setSelectedObjects(s.empties[0]);
  agt.update3d();
  agt.changeSelectedZaunElemente({
    massAuswahlwert: APP.richMetadata.findAuswahlwert("90x180_Easy"),
    maximumNumberOfElements: 1,
  });
  const element = s.getElemente()[0];
  APP.arrangement.setSelectedObjects(element);
  element.snap = 1;
  agt.update3d();
  const elementMeta = APP.richMetadata.findEnsureAnyObjekt(
    "2499 SYSTEM WPC Classic Mass Einzeltor zweiseitig_15"
  );
  getSollZwischenabstandVerbose(element, elementMeta, RECHTS);
  const soll = [LINKS, RECHTS].map((richtung) =>
    getSollZwischenabstandVerbose(element, elementMeta, richtung)
  );
  const massAuswahlwert = APP.richMetadata.findAuswahlwert("Einzeltor_Easy");
  agt.changeSelectedZaunElemente({ massAuswahlwert });
  agt.update3d();
  const ist = [LINKS, RECHTS].map((richtung) =>
    getZwischenabstandAnSeiteVerbose(element, richtung)
  );
  assert.deepEqualsPicked(
    ist,
    soll,
    "assert.deepEquals(soll,ist) failed: rot=getSollZwischenabstandVerbose, grün=getZwischenabstandAnSeiteVerbose"
  );
};

export const testElementNichtLöschenWennGenugPlatz: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [1]);
  const s = agt.segmente[0];
  agt.fillIndividuellSegmentsWithElements();
  agt.update3d();
  agt.grundriss.ecken[1].punkt.x += +3 - 0.04;
  agt.update3d();
  const element = s.getElemente()[0];
  const massAuswahlwert = APP.richMetadata.findAuswahlwert("180x180_Easy");
  APP.arrangement.setSelectedObjects(element);
  agt.changeSelectedZaunElemente({
    massAuswahlwert,
  });
  agt.update3d();
  assert.equals(1, s.getElemente().length, "Anzahl Elemente");
  assert.equals(1.78, element.breite, "Element Breite");
  assert.equals(1.845, element.höhe, "Element Höhe");
};

export const testGrößereBreiteWirdGesetztWennAusreichenderLeerraumNebenNachbarnLinks: Test =
  async () => {
    const massAuswahlwert = APP.richMetadata.findAuswahlwert("180x180_Easy");
    const agt = APP.arrangement;
    resetArrangement();
    agt.grundriss.setStandardForm("Strecke", [4]);
    agt.fillIndividuellSegmentsWithElements();
    agt.update3d();
    const s = agt.segmente[0];
    const element = s.getElemente()[2];
    // Hier setKonfigurierbareBreite() statt setBreite() verwenden, da ohne den Aufruf von
    // segment.repositionAndCheckSnaps() das erste Element gelöscht wird..
    element.setKonfigurierbareBreite(s.getElemente()[0].breite);
    agt.update3d();
    s.getElemente()[0].uiRemove();
    agt.update3d();
    const freiraumBreite = getEntferntAngrenzendeFreiraumBreiteSumme(element);
    assert.equals(1.78, freiraumBreite, "Der gelöschte Platz ist frei");
    APP.arrangement.setSelectedObjects(element);
    agt.changeSelectedZaunElemente({
      massAuswahlwert,
    });
    agt.update3d();
    assert.equals(
      1.78,
      element.breite,
      "Das Element soll die Standardbreite haben, weil es genug Platz gibt"
    );
    assert.equals(2, s.getElemente().length, "Das Nachbarelement soll nicht gelöscht werden");
  };

export const testGrößereBreiteWirdGesetztWennAusreichenderLeerraumNebenNachbarnRechts: Test =
  async () => {
    const massAuswahlwert = APP.richMetadata.findAuswahlwert("180x180_Easy");
    const agt = APP.arrangement;
    resetArrangement();
    agt.grundriss.setStandardForm("Strecke", [4]);
    agt.fillIndividuellSegmentsWithElements();
    agt.update3d();
    const s = agt.segmente[0];
    s.getElemente()[2].uiRemove();
    agt.update3d();
    const element = s.getElemente()[0];
    const freiraumBreite = getEntferntAngrenzendeFreiraumBreiteSumme(element);
    assert.equals(1.78, freiraumBreite, "Der gelöschte Platz ist frei");
    APP.arrangement.setSelectedObjects(element);
    agt.changeSelectedZaunElemente({
      massAuswahlwert,
    });
    agt.update3d();
    assert.equals(
      1.78,
      element.breite,
      "Das Element soll die Standardbreite haben, weil es genug Platz gibt"
    );
    assert.equals(2, s.getElemente().length, "Das Nachbarelement soll nicht gelöscht werden");
  };

export const testMaßelementWPCTor4b289cm: Test = async () => {
  const füllungAuswahlwert = APP.richMetadata.findAuswahlwert("SYSTEM WPC CLASSIC Anthrazit");
  const massAuswahlwert = APP.richMetadata.findAuswahlwert("Einzeltor_Easy");
  const elementMeta = APP.richMetadata.findEnsureAnyObjekt(
    "2137 SYSTEM WPC Standard Einzeltor Classic Anth/Silber DIN Links"
  );
  const agt = APP.arrangement;
  resetArrangement();
  agt.grundriss.setStandardForm("Strecke", [3]);
  agt.fillIndividuellSegmentsWithElements();
  const s = agt.segmente[0];
  const index = 0;
  const element = s.getElemente()[index];
  APP.arrangement.setSelectedObjects(element);
  agt.update3d();
  const soll = [LINKS, RECHTS].map((richtung) =>
    getSollZwischenabstandVerbose(element, elementMeta, richtung)
  );
  element.change({ massAuswahlwert });
  assert.equals(
    füllungAuswahlwert,
    element.füllungAuswahlwert,
    "gewünschte Füllung soll gesetzt sein (1)"
  );
  // Achtung! Wir brauchen jetzt neuerdings 3 update3d??
  agt.update3d();
  const ist = [LINKS, RECHTS].map((richtung) =>
    getZwischenabstandAnSeiteVerbose(element, richtung)
  );
  assert.equals(
    füllungAuswahlwert,
    element.füllungAuswahlwert,
    "gewünschte Füllung soll gesetzt sein (2)"
  );
  assert.deepEquals(
    {
      zwischenabstandLinks: 0.08 + 0.0125 - 0.04,
      zwischenabstandRechts: 0.0125 + 0.08 + 0.03 + -0.02,
    },
    {
      zwischenabstandLinks: getZwischenabstandAnSeite(element, LINKS),
      zwischenabstandRechts: getZwischenabstandAnSeite(element, RECHTS),
    }
  );
  assert.deepEqualsPicked(
    ist,
    soll,
    "assert.deepEquals(soll,ist) failed: rot=getSollZwischenabstandVerbose, grün=getZwischenabstandAnSeiteVerbose"
  );
  checkMass(true, s, agt, füllungAuswahlwert, massAuswahlwert, index, 2);
};

export const testUMProfile: Test = async () => {
  const füllungAuswahlwert = APP.richMetadata.findAuswahlwert("SYSTEM BOARD XL Schiefer");
  const massAuswahlwert = APP.richMetadata.findAuswahlwert("Einzeltor_Easy");
  const elementMeta = APP.richMetadata.findEnsureAnyObjekt("2837 SYSTEM BOARD XL Mass Einzeltor");
  const agt = APP.arrangement;
  resetArrangement();
  agt.grundriss.setStandardForm("Strecke", [3]);
  agt.fillIndividuellSegmentsWithElements();
  agt.update3d();
  const s = agt.segmente[0];
  assertSegmentIstLückenlosGefüllt(s);
  const element = s.getElemente()[0];
  APP.arrangement.setSelectedObjects(element);
  agt.update3d();
  const soll = [LINKS, RECHTS].map((richtung) =>
    getSollZwischenabstandVerbose(element, elementMeta, richtung)
  );
  agt.changeSelectedZaunElemente({
    füllungAuswahlwert,
    massAuswahlwert,
  });
  agt.update3d();
  assert.equals(
    füllungAuswahlwert,
    element.füllungAuswahlwert,
    "gewünschte Füllung soll gesetzt sein"
  );
  assert.equals(2, agt.getTorpfosten().length, "es gibt 2 Torpfosten");
  const ist = [LINKS, RECHTS].map((richtung) =>
    getZwischenabstandAnSeiteVerbose(element, richtung)
  );
  assert.deepEqualsPicked(
    soll,
    ist,
    "assert.deepEquals(soll,ist) failed: rot=getSollZwischenabstandVerbose, grün=getZwischenabstandAnSeiteVerbose"
  );
  assert.equals(1, s.getUMProfile().length, "Anzahl UMProfile");
  const torpfostenMitUMProfil = agt.getPfosten().find((p) => p.elemente.length == 2);
  assert.isTrue(
    (torpfostenMitUMProfil.nachbarRechts as any).isUMProfil,
    "das UMProfil ist an der richtigen Stelle"
  );
  checkMass(true, s, agt, füllungAuswahlwert, massAuswahlwert, 0, 2);
  assertSegmentIstLückenlosGefüllt(s);
};

export const testStandardVsMassEinzeltorDirect: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [2]);
  agt.fillIndividuellSegmentsWithElements();
  const s = agt.segmente[0];
  s.getElemente()[0].uiRemove();
  agt.update3d();
  const element = s.getElemente()[0];
  const massAuswahlwert = APP.richMetadata.findAuswahlwert("Einzeltor_Easy");
  element.massAuswahlwert = massAuswahlwert;
  element.rahmenAuswahlwert = APP.richMetadata.findAuswahlwert("Tor_Rahmen_Anthrazit");
  element.form = findPathIntersectionCached("TestInsertMasselementeAutomatisch.ts:434")(
    massAuswahlwert,
    (p: PAuswahlwert) => p.Mass.Form
  ) as MObjekt;
  element.setBreite(0.98);
  element.höhe = 1.8;
  agt.update3d();
  assert.deepEquals(
    {
      breite: 0.98,
      höhe: 1.8,
      key: "2570 SYSTEM WPC Standard Einzeltor Classic Anth/Anth DIN Links",
    },
    { breite: element.breite, höhe: element.höhe, key: element.meta.Key },
    "Massauswahlwert auf Standardtor gesetzt"
  );
  _.range(0.96, 1, 0.01).map((breite) =>
    _.range(1.8, 1.78, -0.01).map((höhe) => {
      element.setBreite(breite);
      element.höhe = höhe;
      agt.update3d();
      assert.deepEquals(
        {
          breite,
          höhe,
          key:
            Maths.equalsEpsilon(0.98, breite, nullEpsilon) &&
            Maths.equalsEpsilon(1.8, höhe, nullEpsilon)
              ? "2570 SYSTEM WPC Standard Einzeltor Classic Anth/Anth DIN Links"
              : "2499 SYSTEM WPC Classic Mass Einzeltor zweiseitig_15",
        },
        { breite: element.breite, höhe: element.höhe, key: element.meta.Key },
        "Mass gesetzt"
      );
    })
  );
};

export const testStandardVsMassEinzeltorChange: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [2]);
  agt.fillIndividuellSegmentsWithElements();
  const s = agt.segmente[0];
  s.getElemente()[0].uiRemove();
  agt.update3d();
  const element = s.getElemente()[0];
  const massAuswahlwert = APP.richMetadata.findAuswahlwert("Einzeltor_Easy");
  element.rahmenAuswahlwert = APP.richMetadata.findAuswahlwert("Tor_Rahmen_Anthrazit");
  element.form = findPathIntersectionCached("TestInsertMasselementeAutomatisch.ts:480")(
    massAuswahlwert,
    (p: PAuswahlwert) => p.Mass.Form
  ) as MObjekt;
  element.change({
    massAuswahlwert,
  });
  agt.update3d();
  assert.deepEquals(
    {
      breite: 0.98,
      höhe: 1.8,
      key: "2570 SYSTEM WPC Standard Einzeltor Classic Anth/Anth DIN Links",
    },
    { breite: element.breite, höhe: element.höhe, key: element.meta.Key },
    "Massauswahlwert auf Standardtor gesetzt"
  );
  _.range(0.96, 1, 0.01).map((breite) =>
    _.range(1.8, 1.78, -0.01).map((höhe) => {
      element.change({
        massAuswahlwert,
        size: v2(breite, höhe),
      });
      element.setBreite(breite);
      element.höhe = höhe;
      agt.update3d();
      assert.deepEquals(
        {
          breite,
          höhe,
          key:
            Maths.equalsEpsilon(0.98, breite, nullEpsilon) &&
            Maths.equalsEpsilon(1.8, höhe, nullEpsilon)
              ? "2570 SYSTEM WPC Standard Einzeltor Classic Anth/Anth DIN Links"
              : "2499 SYSTEM WPC Classic Mass Einzeltor zweiseitig_15",
        },
        { breite: element.breite, höhe: element.höhe, key: element.meta.Key },
        "Mass gesetzt"
      );
    })
  );
};

export const testMasselementWeilBauseits: Test = async () => {
  await checkMassAuto({
    füllungAuswahlwert: APP.richMetadata.findAuswahlwert("SYSTEM WPC CLASSIC Anthrazit"),
    massAuswahlwert: APP.richMetadata.findAuswahlwert("180x180_Easy"),
    sollMassSein: true,
  });
};

export const testKeinMasselementWeilGenugPlatz: Test = async () => {
  const füllungAuswahlwert = APP.richMetadata.findAuswahlwert("SYSTEM WPC CLASSIC Anthrazit");
  const massAuswahlwert = APP.richMetadata.findAuswahlwert("180x180_Easy");
  const agt = APP.arrangement;
  resetArrangement();
  agt.grundriss.setStandardForm("Strecke", [3]);
  const s = agt.segmente[0];
  agt.update3d();
  agt.fillIndividuellSegmentsWithElements();
  agt.getElemente()[1].uiRemove();
  agt.update3d();
  APP.arrangement.setSelectedObjects(agt.getElemente().slice(0, 1));
  agt.update3d();
  agt.changeSelectedZaunElemente({
    füllungAuswahlwert,
    massAuswahlwert,
  });
  assert.equals(1, s.getElemente().length);
  assert.equals(1.78, s.getElemente()[0].breite);
};

export const testMaßelementWeilTorBoardXL: Test = async () => {
  await checkMassAuto({
    füllungAuswahlwert: APP.richMetadata.findAuswahlwert("SYSTEM BOARD XL Schiefer"),
    massAuswahlwert: APP.richMetadata.findAuswahlwert("Einzeltor_Easy"),
    sollMassSein: true,
  });
};

export const testMaßelementWeilTorWPCClassic: Test = async () => {
  await checkMassAuto({
    füllungAuswahlwert: APP.richMetadata.findAuswahlwert("SYSTEM WPC CLASSIC Anthrazit"),
    massAuswahlwert: APP.richMetadata.findAuswahlwert("Einzeltor_Easy"),
    sollMassSein: true,
  });
};

export const testKeinMaßelementWeilFix: Test = async () => {
  await checkMassAuto({
    füllungAuswahlwert: APP.richMetadata.findAuswahlwert("SYSTEM BOARD XL Schiefer"),
    massAuswahlwert: APP.richMetadata.findAuswahlwert("180x180_Easy"),
    sollMassSein: false,
    breitesFixElement: true,
  });
};

export const testMaßelementWeilFertigung: Test = async () => {
  await checkMassAuto({
    füllungAuswahlwert: APP.richMetadata.findAuswahlwert("SYSTEM GLAS Texta"),
    massAuswahlwert: APP.richMetadata.findAuswahlwert("120x180_Easy"),
    sollMassSein: true,
  });
};

export const testMaßTorSelektionSollNichtVerschwinden: Test = async () => {
  const füllungAuswahlwert = APP.richMetadata.findAuswahlwert("SYSTEM WPC CLASSIC Anthrazit");
  const massAuswahlwert = APP.richMetadata.findAuswahlwert("180x180_Easy");
  const agt = APP.arrangement;
  resetArrangement();
  agt.grundriss.setStandardForm("Strecke", [0.8]);
  const s = agt.segmente[0];
  agt.update3d();
  APP.arrangement.setSelectedObjects(s.empties);
  agt.update3d();
  assert.equals(1, agt.selectedObjects.length, "Die Selektion soll nicht verschwinden");
  agt.changeSelectedZaunElemente({
    füllungAuswahlwert,
    massAuswahlwert,
  });
  assert.equals(1, agt.selectedObjects.length, "Die Selektion soll nicht verschwinden");
};

async function checkMassAuto({
  füllungAuswahlwert,
  massAuswahlwert,
  sollMassSein,
  breitesFixElement = false,
}) {
  const agt = APP.arrangement;
  agt.bodenbefestigungAuswahlwertDefault =
    APP.richMetadata.findAuswahlwert("Einbetoniert im Boden");
  const index = 0;
  await subTestContext(
    "Testsituation 1: in einem ausreichend breiten Segment wird der Leerraum gefüllt: ",
    () => {
      resetArrangement();
      agt.grundriss.setStandardForm("Strecke", [4]);
      const s = agt.segmente[0];
      agt.update3d();
      APP.arrangement.setSelectedObjects(s.empties);
      agt.update3d();
      agt.changeSelectedZaunElemente({
        füllungAuswahlwert,
        massAuswahlwert,
      });
      const element = createElement(agt, {
        füllungAuswahlwert,
        massAuswahlwert,
        size: undefined,
      });
      if (element.isTor) {
        assert.equals(1, s.getElemente().length);
        assert.equals(element.breite, s.getElemente()[0].breite);
      } else if (sollMassSein) {
        assertSegmentIstLückenlosGefüllt(s);
      } else {
        assert.isTrue(s.getElemente().length > 1);
        s.getElemente().forEach((e) => assert.equals(element.breite, e.breite));
      }
      assert.equals(
        füllungAuswahlwert,
        agt.getElemente()[0].füllungAuswahlwert,
        "gewünschte Füllung soll gesetzt sein"
      );
    }
  );
  await subTestContext(
    "Testsituation 2: in einem schmalen Segment wird der Leerraum gefüllt: ",
    () => {
      resetArrangement();
      agt.grundriss.setStandardForm("Strecke", [0.8]);
      const s = agt.segmente[0];
      agt.update3d();
      APP.arrangement.setSelectedObjects(s.empties);
      agt.update3d();
      agt.changeSelectedZaunElemente({
        füllungAuswahlwert,
        massAuswahlwert,
      });
      if (!sollMassSein) {
        assert.equals(1, s.getElemente().length);
      } else {
        checkMass(sollMassSein, s, agt, füllungAuswahlwert, massAuswahlwert, index, 1);
        if (agt.getElemente()[index]) {
          assert.equals(
            füllungAuswahlwert,
            agt.getElemente()[index].füllungAuswahlwert,
            "gewünschte Füllung soll gesetzt sein"
          );
        }
      }
    }
  );
  await subTestContext(
    "Testsituation 3: in einem Segment wird der schmale Leerraum neben einem anderen Element gefüllt: ",
    () => {
      resetArrangement();
      agt.grundriss.setStandardForm("Strecke", [2]);
      const s = agt.segmente[0];
      agt.update3d();
      agt.fillIndividuellSegmentsWithElements();
      agt.update3d();
      agt.getElemente()[0].uiRemove();
      agt.update3d();
      APP.arrangement.setSelectedObjects(s.empties);
      agt.update3d();
      agt.changeSelectedZaunElemente({
        füllungAuswahlwert,
        massAuswahlwert,
      });
      agt.update3d();
      if (!sollMassSein) {
        assert.equals(2, s.getElemente().length);
      } else {
        checkMass(sollMassSein, s, agt, füllungAuswahlwert, massAuswahlwert, index, 1);
        assert.equals(
          füllungAuswahlwert,
          agt.getElemente()[index].füllungAuswahlwert,
          "gewünschte Füllung soll gesetzt sein"
        );
      }
    }
  );
  const subTestsituation4 = async (description, breite, params) =>
    await subTestContext(
      `Testsituation 4: ein vorhandenes ${
        breitesFixElement ? "breites" : "schmales"
      } Element in einer vollen Strecke von ${breite} m wird verändert: ${description}:`,
      () => {
        const index = breitesFixElement ? 1 : 0;
        resetArrangement();
        agt.grundriss.setStandardForm("Strecke", [breite]);
        agt.fillIndividuellSegmentsWithElements();
        const s = agt.segmente[0];
        const element = agt.getElemente()[index];
        APP.arrangement.setSelectedObjects(element);
        agt.update3d();
        if (!params.massAuswahlwert) {
          agt.changeSelectedZaunElemente({ massAuswahlwert });
          agt.update3d();
        }
        agt.changeSelectedZaunElemente(params);
        agt.update3d();
        agt.update3d();
        assert.isTrue(s.parts.includes(element), "element darf nicht gelöscht sein");
        if (params.füllungAuswahlwert) {
          assert.equals(
            params.füllungAuswahlwert,
            element.füllungAuswahlwert,
            "gewünschte Füllung soll gesetzt sein"
          );
        }
        checkMass(sollMassSein, s, agt, füllungAuswahlwert, massAuswahlwert, index, 2);
      }
    );
  for (const breite of [2.89 - 0.08, 3 - 0.08, 3.08 - 0.08]) {
    await subTestsituation4("Untertest a) changeSelectedZaunElemente mit Füllung", breite, {
      füllungAuswahlwert,
    });
    if (sollMassSein) {
      await subTestsituation4("Untertest b) changeSelectedZaunElemente mit Maß", breite, {
        massAuswahlwert,
      });
      await subTestsituation4(
        "Untertest c) changeSelectedZaunElemente mit Füllung und Maß",
        breite,
        {
          füllungAuswahlwert,
          massAuswahlwert,
        }
      );
    }
  }

  const subTestsituation5 = async (description, params) =>
    await subTestContext(
      "Testsituation 5: ein vorhandenes breites Element in einer ansonsten ausreichend großen leeren Strecke wird verändert: " +
        description +
        ":",
      () => {
        resetArrangement();
        agt.grundriss.setStandardForm("Strecke", [4]);
        const s = agt.segmente[0];
        const element = agt.createDefaultElement();
        s.addPart(element);
        agt.update3d();
        APP.arrangement.setSelectedObjects(s.getElemente()[index]);
        agt.update3d();
        agt.changeSelectedZaunElemente(params);
        agt.update3d();
        assert.equals(1, s.getElemente().length);
        if (params.füllungAuswahlwert) {
          assert.equals(
            params.füllungAuswahlwert,
            agt.getElemente()[index].füllungAuswahlwert,
            "gewünschte Füllung soll gesetzt sein"
          );
        }
        if (params.massAuswahlwert) {
          const standardElement = createElement(agt, {
            füllungAuswahlwert: s.getElemente()[0].füllungAuswahlwert,
            massAuswahlwert,
            size: undefined,
          });
          assert.equals(standardElement.breite, s.getElemente()[index].breite);
        }
      }
    );
  await subTestsituation5("Untertest a) changeSelectedZaunElemente mit Füllung", {
    füllungAuswahlwert,
  });
  await subTestsituation5("Untertest b) changeSelectedZaunElemente mit Maß", {
    massAuswahlwert,
  });
  await subTestsituation5("Untertest c) changeSelectedZaunElemente mit Füllung und Maß", {
    füllungAuswahlwert,
    massAuswahlwert,
  });

  await subTestContext(
    "Testsituation 6: soll und ist Zwischenabstand sollen gleich sein, wenn das Element auf seine eigenen Auswahlwerte geändert wird:",
    () => {
      resetArrangement();
      agt.grundriss.setStandardForm("Strecke", [4]);
      const s = agt.segmente[0];
      agt.update3d();
      APP.arrangement.setSelectedObjects(s.empties);
      agt.update3d();
      agt.changeSelectedZaunElemente({
        füllungAuswahlwert,
        massAuswahlwert,
      });
      const element = agt.getElemente()[0];
      agt.update3d();
      assertEqualsZwischenabstandSollIst(element);
      assert.equals(
        füllungAuswahlwert,
        element.füllungAuswahlwert,
        "gewünschte Füllung soll gesetzt sein"
      );
    }
  );
}

function checkMass(
  sollMassSein: boolean,
  s: Segment,
  agt: Arrangement,
  füllungAuswahlwert,
  massAuswahlwert,
  index,
  sollAnzahlElemente
) {
  if (sollMassSein) {
    assertSegmentIstLückenlosGefüllt(s);
  } else {
    const standardElement = createElement(agt, {
      füllungAuswahlwert,
      massAuswahlwert,
      size: undefined,
    });
    assert.equals(sollAnzahlElemente, s.getElemente().length);
    assert.equals(standardElement.breite, s.getElemente()[index].breite);
  }
}

function assertEqualsZwischenabstandSollIst(element: ZElement) {
  const soll = [LINKS, RECHTS].map((richtung) =>
    getSollZwischenabstandVerbose(element, element.meta, richtung)
  );

  const füllungAuswahlwert = element.füllungAuswahlwert;

  element.change({
    füllungAuswahlwert: element.füllungAuswahlwert,
    massAuswahlwert: element.massAuswahlwert,
    maximalBreite: element.breite,
  } as any);

  const ist = [LINKS, RECHTS].map((richtung) =>
    getZwischenabstandAnSeiteVerbose(element, richtung)
  );

  assert.deepEqualsPicked(
    ist,
    soll,
    "assert.deepEquals(soll,ist) failed: rot=getSollZwischenabstandVerbose, grün=getZwischenabstandAnSeiteVerbose"
  );
  assert.equals(füllungAuswahlwert, element.füllungAuswahlwert, "Füllung soll gleich bleiben");
}

export const testSollIstIdentisch: Test = async () => {
  const agt = APP.arrangement;
  agt.bodenbefestigungAuswahlwertDefault =
    APP.richMetadata.findAuswahlwert("Einbetoniert im Boden");
  resetArrangement();
  agt.grundriss.setStandardForm("Strecke", [4]);
  const s = agt.segmente[0];
  agt.update3d();
  const füllungAuswahlwert = APP.richMetadata.findAuswahlwert("SYSTEM BOARD XL Schiefer");
  const massAuswahlwert = APP.richMetadata.findAuswahlwert("180x180_Easy");
  APP.arrangement.setSelectedObjects(s.empties);
  agt.update3d();
  agt.changeSelectedZaunElemente({
    füllungAuswahlwert,
    massAuswahlwert,
  });
  const element = agt.getElemente()[0];

  const angrenzendeTeile = getAngrenzendeTeile(element, RECHTS);
  assert.isNull(angrenzendeTeile.ecke, "rechts steht ja noch ein Element");
  const zwischenabstand = getZwischenabstandAnSeiteVerbose(element, RECHTS);
  console.log({ angrenzendeTeile, zwischenabstand });
  // getSollZwischenabstandVerbose(element, element.meta, RECHTS);
  agt.update3d();
  assertEqualsZwischenabstandSollIst(element);
  assert.equals(
    füllungAuswahlwert,
    element.füllungAuswahlwert,
    "gewünschte Füllung soll gesetzt sein"
  );
};
